import React, {useState,useEffect} from "react";
import { configData } from "../config";
import { useNavigate,useLocation,useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import './classes/ScoutMyReports.css';
import ScoutSidebar from './ScoutSidebar';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from "@mui/material";
import SalespersonSidebar from "./SalespersonSidebar";

const columns = [   
    {
        field: 'title',
        headerName: 'Title',
        headerClassName: 'super-app-theme--header',
        minWidth: 105, 
        flex:1,
        sortable: false,
        filterable: false,     
        renderCell: (params) => (
            <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.title}
            </Link>
        ), 
    },
    {
        field: 'date_uploaded',
        headerName: 'Date Uploaded',
        headerClassName: 'super-app-theme--header',
        minWidth: 110, 
        flex:1,
        sortable: false,
        filterable: false,  
    },
    {
        field: 'sport',
        headerName: 'Sport',
        headerClassName: 'super-app-theme--header',
        minWidth: 95, 
        flex:1,
        sortable: false,
        filterable: false,  
    },
    {
        field: 'operations',
        headerName: 'Operations',
        headerClassName: 'super-app-theme--header',
        minWidth: 130, 
        flex:1,     
        sortable: false,
        filterable: false,
        renderCell: (params) => (
            <>
                <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                    {params.row.linkText || 'Edit'}
                </Link>
                <span>&nbsp;|&nbsp;</span>
                <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                    {params.row.linkText || 'Delete'}
                </Link>
            </>
        ),
    },
]; 

// const rows = [
//     {
//         title: "test gret",
//         date_uploaded: "19-10-25",
//         sport: "action sports"
//     }
// ]

const ScoutMyReports = () => {

    const [isLoading, setIsLoading] = useState(true);  
    const[message,setMessage] = useState([]);
    const location  = useLocation();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    const domainName = window.location.host.replace(/^https?:\/\//, '');
    var {uid} = useParams();

    // const successMessage = location.state?.message;
const[successMessage,setSuccess] = useState('');
const Message = location.state?.message;
    useEffect(() => {
      if (Message) {
        setSuccess(Message);
        window.history.replaceState({}, '');
      }
    }, [Message, location.state]);

    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });

    useEffect(() => {
        Promise.all([
            checkpermissionforpageaccess()
        ])
        .then(() => {
        
            setIsLoading(false);
        })
        
    },[]);
    
    async function checkpermissionforpageaccess() {
       
          
               const response = await fetch(
                    app_url+'smwwscout/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                   {
                       method: "GET",
     
                       headers: {
                       'Content-Type': 'application/json',
                       },
                   }
               )           
               const responsedata = await response.json();
               if(responsedata.data.msg === "Success") {
                   
               } 
                if(responsedata.data.msg === "Error") {
                   setMessage(responsedata.data.result);
               } 
   
          
       }
     React.useEffect(() => {
            const fetchData = async () => {
              // Simulate API call to your server
              // In a real application, replace this with your actual fetch logic
               try {
                const response = await fetch(app_url+'smwwscout/getmyscoutreportlist', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                    sortModel,
                    filterModel,
                    drupal_uid: localStorage.getItem('drupal_uid')
                    }),
                });
                const data = await response.json();
                console.log(data.data.rows);
                setRows(data.data.rows);
                setRowCount(data.data.totalRowCount); // Server should return totalRowCount
                // console.log("Type of totalRowCount:", typeof data.data.totalRowCount);
            }  catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
            }
          
        
            };
        
            fetchData();
          }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>My Uploaded Reports</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="my-reports-container">
                       {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                            {message.length > 0 ? (
                <div>
                  {message.map((item, index) => {
                    return <><div dangerouslySetInnerHTML={{ __html: item }} /><br /></>
          
                  })}  
                </div>
              ) : (
                            <><h1>My Uploaded Reports</h1>
                            <div className="my-reports-table" style={{ width: '100%', overflowX: 'auto'}}>
                                <DataGrid
                                    autoHeight
                                    rows={rows}
                                    columns={columns} 
                                    rowCount={rowCount}
                                    disableAutosize
                                    getRowHeight={() => 'auto'}
                                    paginationMode="server"
                                    sortingMode="server"
                                    filterMode="server"
                                    filterModel={filterModel}
                                    onFilterModelChange={setFilterModel}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    onSortModelChange={setSortModel}
                                    pageSizeOptions={[5, 10, 25, 50]}
                                    pageSize={50}
                                    getRowId={() => crypto.randomUUID()}                                                                 
                                    sx={{
                                        fontFamily: '"Open Sans", sans-serif, Arial, Verdana',
                                        '& .MuiDataGrid-row': { marginTop: 1, marginBottom: 1 },
                                        '& .coloured': { textAlign: 'center', color: '#7181AD' },
                                        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'block' },
                                        '& .super-app-theme--header': { fontSize: '14px' },
                                        '.MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold !important',whiteSpace:'normal' },
                                        '& .MuiDataGrid-cell': {
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        lineHeight: '1.4',
                                        alignItems: 'center',
                                        display: 'flex',
                                        },
                                        // '& .MuiTablePagination-actions': { marginRight: 10 },
                                        '& .header-link':{color: "#2C99D2"},
                                    }}
                                    disableColumnResize={true}
                                />
                            </div></>
              )}
                        </div>
                    </div>
                    <div className="right">
                        {/* <ScoutSidebar /> */}
                        {/* {
                            userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                            userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                            userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)
                            ? <SalespersonSidebar />
            
                            : domainName === configData.RSMWW_SCOUT_DOMAIN &&
                                userLoggedInRoles.includes(configData.ROLE_SCOUT)
                            ? <ScoutSidebar />
            
                            :  <div>
                    <h1>Quick Links</h1>
                    <ul style={{padding: "0px"}}>
                        <li className='salesperson-header-hello-text'><a href={"/user/"+userLoggedInId.drupal_uid+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                        <li>
                        <a href="/smww_pay">
                        <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                        </a>
                        </li>           */}
                        {/* {localStorage.getItem('masquerade') == 1 && (
                            <li>
                            <a className="salesperson-quick_link_anchor" href={/miscellaneous/charge/${drupal_uid}}>
                                Miscellaneous Charge
                            </a>
                            </li>
                        )} */}
                    {/* </ul>
                  </div>
                        } */}
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default ScoutMyReports;